import * as Yup from 'yup';

const templateTitle = Yup.string()
  .trim();

export default templateTitle;
